import { createSlice } from "@reduxjs/toolkit";
import { getAllLiked,addLiked, removeOneLiked } from "./liked-actions";

const likedSlice = createSlice({
  name: "liked",
  initialState: {
    loading: true,
    images: [],
    error: "",
  },
  reducers: {},
  extraReducers: {
    [getAllLiked.fulfilled]: (state,action) => {
        state.loading = false;
        state.images = action.payload.images;
    },
    [getAllLiked.rejected]: (state,action) => {
        state.loading = false;
        state.error = action.payload;
    },
    [addLiked.fulfilled]: (state,action) => {
        state.loading = false;
        state.images = action.payload.images;
    },
    [addLiked.rejected]: (state,action) => {
        state.loading = false;
        state.error = action.payload;
    },
    [removeOneLiked.fulfilled]: (state,action) => {
        state.loading = false;
        state.images = action.payload.images;
    },
    [removeOneLiked.rejected]: (state,action) => {
        state.loading = false;
        state.error = action.payload;
    },
  },
});

export const likedActions = likedSlice.actions;
export default likedSlice;
